import { GridItemNormalizer } from '../types';

export default class UserObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_User';
  }

  normalize(value: any) {
    return value?.full_name || value?.email;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      full_name: '',
      email: '',
    };
  }
}
